// extracted by mini-css-extract-plugin
export default {"tile":"recommendationsxwzyup","tile--super-offer":"recommendationsi9pyFR","tile__anchor":"recommendations3htwP-","tile__actions":"recommendationsQw4KLX"};